'use client'

import Player1 from 'images/home/rating1_x2.png'
import Player2 from 'images/home/rating2_x2.png'
import Player3 from 'images/home/rating3_x2.png'
import Player4 from 'images/home/rating4_x2.png'
import Image from 'next/image'
import { TrackExposure, TrackHomeSection } from 'modules/analysis'

const list = [Player1, Player2, Player3, Player4]

export function Players() {
  return (
    <TrackExposure config={{ sectionName: TrackHomeSection.Ratings }}>
      <div className="max-section grid w-full grid-cols-4">
        {list.map((image, index) => (
          <div
            className="hover-zoom-110 cursor-default! relative first:hover:translate-x-[5%] last:hover:-translate-x-[5%]"
            key={index}
          >
            <Image className="h-auto w-full" src={image} alt={`rating_${index}`} width={480} height={776} />
          </div>
        ))}
      </div>
    </TrackExposure>
  )
}
